import { useOutletContext } from 'react-router-dom'

import ExpensesList from 'modules/expenses/components/expenses/List'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import type { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { EXPENSES_SYNC_CONFIGURATION } from 'modules/expenses/pages/SyncConfiguration'
import { IntegrationsSyncContextProvider } from 'modules/integrations/public'

const ExpensesListTab = () => {
  const { onAddUsers } = useOutletContext<TabRouteContextParams>()
  const { navigation } = useExpensesNavigation()

  return (
    <IntegrationsSyncContextProvider configuration={EXPENSES_SYNC_CONFIGURATION}>
      <ExpensesList back={{ href: navigation.list.fullPath() }} onAddUsers={onAddUsers} />
    </IntegrationsSyncContextProvider>
  )
}

export default ExpensesListTab
